/* src/app/home/partials/collections-due-today/collections-due-today.component.scss */
b {
  color: #1e293b;
  font-size: 0.95rem;
}
hr {
  margin: 0.5rem 0 0.75rem;
  border-color: #eef2f6;
}
.statRow {
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}
.statNumber {
  font-size: 2.25rem;
  font-weight: 700;
  color: #f99420;
  line-height: 1;
}
.statLabel {
  color: #64748b;
  font-size: 0.85rem;
}
.miniList {
  list-style: none;
  margin: 0;
  padding: 0;
}
.miniList li {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
  border-top: 1px solid #f1f5f9;
  font-size: 0.85rem;
  color: #334155;
}
.miniList li:first-child {
  border-top: none;
}
.miniList .time {
  flex: 0 0 auto;
  min-width: 3rem;
  font-weight: 600;
  color: #006498;
}
.miniList .details {
  color: #475569;
}
/*# sourceMappingURL=collections-due-today.component.css.map */
